<div class="ibox detailed-view-ibox"
     *ngIf="settingsEmailMergeService.showDetailedView && settingsEmailMergeService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">{{settingsEmailMergeService.chosenCorporation.name}}</div>
        <span class="close-detailed-view" (click)="settingsEmailMergeService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form #form="ngForm" submittable autocomplete="off">
                <!--<div>-->
                    <!--<div class="detailed-view-navigation">-->
                        <!--<div class="col-md-6 col-sm-6 col-xs-6 no-padding">-->
                            <!--<div class="button-section"-->
                                 <!--(click)="changeNavPosition('tab_settings')"-->
                                 <!--[ngStyle]="{'background-color': navPosition == 'tab_settings' ? '#ebebeb' : ''}">-->
                                <!--Tab Settings-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="col-md-6 col-sm-6 col-xs-6 no-padding">-->
                            <!--<div class="button-section"-->
                                 <!--(click)="changeNavPosition('notifications')"-->
                                 <!--[ngStyle]="{'background-color': navPosition == 'notifications' ? '#ebebeb' : ''}">-->
                                <!--Notifications-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
                <div class="services-list" *ngIf="navPosition == 'tab_settings'">
                    <div class="row m-b-sm" (dblclick)="isFromEditMode = true;">
                        <div class="dv-label col-sm-4">
                            <label>Email Sender Email</label>
                        </div>
                        <div class="dv-value col-sm-8 fourteenPixelText" *ngIf="!isFromEditMode">
                            <span>{{settingsEmailMergeService.selectedItemData.emailSender || '-'}}</span>
                            <i class="fa fa-pencil pull-right"
                               (click)="isFromEditMode = true;"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8 fourteenPixelText" *ngIf="isFromEditMode">
                            <input name="emailSender"
                                   class="form-control"
                                   type="email"
                                   maxlength="255"
                                   pattern="^[0-9a-zA-Z_\.\-\+]+@[0-9a-zA-Z_.-]+?\.[0-9a-zA-Z]{2,3}$"
                                   (keyup.enter)="isChangedEmailValid(form.value.emailSender)"
                                   [ngModel]="settingsEmailMergeService.selectedItemData.emailSender">
                            <button type="button"
                                    [disabled]="disabledSenderSubmit"
                                    (click)="isChangedEmailValid(form.value.emailSender)">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="isFromEditMode = false;">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-sm"
                         (dblclick)="setEditModeFor(settingsEmailMergeService.selectedItemData, 'emailSenderName', true)">
                        <div class="dv-label col-sm-4">
                            <label>Email Sender Name</label>
                        </div>
                        <div class="dv-value col-sm-8 fourteenPixelText"
                             *ngIf="!settingsEmailMergeService.selectedItemData.formFields?.emailSenderName.editMode">
                            <span>{{settingsEmailMergeService.selectedItemData.emailSenderName || '-'}}</span>
                            <i class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(settingsEmailMergeService.selectedItemData, 'emailSenderName', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8 fourteenPixelText"
                             *ngIf="settingsEmailMergeService.selectedItemData.formFields?.emailSenderName.editMode">
                            <input name="emailSenderName"
                                   class="form-control"
                                   maxlength="255"
                                   (keyup.enter)="applyChanges(settingsEmailMergeService.selectedItemData, form, {emailSenderName: form.value.emailSenderName}, 'emailSenderName')"
                                   [ngModel]="settingsEmailMergeService.selectedItemData.emailSenderName">
                            <button type="button"
                                    [disabled]="disabledSenderSubmit"
                                    (click)="applyChanges(settingsEmailMergeService.selectedItemData, form, {emailSenderName: form.value.emailSenderName}, 'emailSenderName')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(settingsEmailMergeService.selectedItemData, 'emailSenderName', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <hr>

                    <div class="slider-container m-t-md">
                        <span>Draft Auto Save</span>
                        <mat-slide-toggle name="draftAutoSave"
                                          (change)="onSubmit({draftAutoSave: form.value.draftAutoSave})"
                                          [ngModel]="settingsEmailMergeService.selectedItemData.draftAutoSave">
                        </mat-slide-toggle>
                    </div>
                </div>
                <!--<div *ngIf="navPosition == 'notifications'">-->
                    <!--<div class="settings-amenities-slider-container m-t-sm">-->
                        <!--<span>Notify Staff</span>-->
                    <!--</div>-->
                    <!--<div class="m-b-xs filter-checkbox">-->
                        <!--<label class="img-checkbox">-->
                            <!--<input type="checkbox"-->
                                   <!--[(ngModel)]="settingsEmailMergeService.keyCreatedStaffCheckbox"-->
                                   <!--[disabled]="!emailTemplateIsSet('created')"-->
                                   <!--name="keyCreatedStaffCheckbox"-->
                                   <!--id="keyCreatedStaffCheckbox"-->
                                   <!--(change)="submitNotificationsField()">-->
                            <!--<label for="keyCreatedStaffCheckbox"-->
                                   <!--[title]="!emailTemplateIsSet('created') ? 'Please select email template first' : ''">-->
                                <!--<svg-checked></svg-checked>-->
                            <!--</label>-->
                        <!--</label>-->
                        <!--<span class="mtv-primary-color clickable-text" (click)="showNotificationModal('created')">-->
                            <!--Key Created-->
                        <!--</span>-->
                    <!--</div>-->
                    <!--<div class="m-b-xs" *ngIf="settingsEmailMergeService.keyCreatedStaffCheckbox">-->
                        <!--<multiselect-field name="createdStaffMultiselect"-->
                                           <!--[data]="settingsEmailMergeService.userRoles"-->
                                           <!--[(ngModel)]="settingsEmailMergeService.createdStaffMultiselectArray"-->
                                           <!--(update)="submitNotificationsField()">-->
                        <!--</multiselect-field>-->
                    <!--</div>-->

                    <!--<div class="m-b-xs filter-checkbox">-->
                        <!--<label class="img-checkbox">-->
                            <!--<input type="checkbox"-->
                                   <!--[(ngModel)]="settingsEmailMergeService.keyDeletedStaffCheckbox"-->
                                   <!--[disabled]="!emailTemplateIsSet('deleted')"-->
                                   <!--name="keyDeletedStaffCheckbox"-->
                                   <!--id="keyDeletedStaffCheckbox"-->
                                   <!--(change)="submitNotificationsField()">-->
                            <!--<label for="keyDeletedStaffCheckbox"-->
                                   <!--[title]="!emailTemplateIsSet('deleted') ? 'Please select email template first' : ''">-->
                                <!--<svg-checked></svg-checked>-->
                            <!--</label>-->
                        <!--</label>-->
                        <!--<span class="mtv-primary-color clickable-text" (click)="showNotificationModal('deleted')">-->
                            <!--Key Deleted-->
                        <!--</span>-->
                    <!--</div>-->
                    <!--<div class="m-b-xs" *ngIf="settingsEmailMergeService.keyDeletedStaffCheckbox">-->
                        <!--<multiselect-field name="deletedStaffMultiselect"-->
                                           <!--[data]="settingsEmailMergeService.userRoles"-->
                                           <!--[(ngModel)]="settingsEmailMergeService.deletedStaffMultiselectArray"-->
                                           <!--(update)="submitNotificationsField()">-->
                        <!--</multiselect-field>-->
                    <!--</div>-->

                    <!--<div class="m-b-xs filter-checkbox">-->
                        <!--<label class="img-checkbox">-->
                            <!--<input type="checkbox"-->
                                   <!--[(ngModel)]="settingsEmailMergeService.keyModifiedStaffCheckbox"-->
                                   <!--[disabled]="!emailTemplateIsSet('modified')"-->
                                   <!--name="keyModifiedStaffCheckbox"-->
                                   <!--id="keyModifiedStaffCheckbox"-->
                                   <!--(change)="submitNotificationsField()">-->
                            <!--<label for="keyModifiedStaffCheckbox"-->
                                   <!--[title]="!emailTemplateIsSet('modified') ? 'Please select email template first' : ''">-->
                                <!--<svg-checked></svg-checked>-->
                            <!--</label>-->
                        <!--</label>-->
                        <!--<span class="mtv-primary-color clickable-text" (click)="showNotificationModal('modified')">-->
                            <!--Key Modified-->
                        <!--</span>-->
                    <!--</div>-->
                    <!--<div class="m-b-xs" *ngIf="settingsEmailMergeService.keyModifiedStaffCheckbox">-->
                        <!--<multiselect-field name="modifiedStaffMultiselect"-->
                                           <!--[data]="settingsEmailMergeService.userRoles"-->
                                           <!--[(ngModel)]="settingsEmailMergeService.modifiedStaffMultiselectArray"-->
                                           <!--(update)="submitNotificationsField()">-->
                        <!--</multiselect-field>-->
                    <!--</div>-->

                    <!--<div class="m-b-xs filter-checkbox">-->
                        <!--<label class="img-checkbox">-->
                            <!--<input type="checkbox"-->
                                   <!--[(ngModel)]="settingsEmailMergeService.keySignedOutStaffCheckbox"-->
                                   <!--[disabled]="!emailTemplateIsSet('signed_out')"-->
                                   <!--name="keySignedOutStaffCheckbox"-->
                                   <!--id="keySignedOutStaffCheckbox"-->
                                   <!--(change)="submitNotificationsField()">-->
                            <!--<label for="keySignedOutStaffCheckbox"-->
                                   <!--[title]="!emailTemplateIsSet('signed_out') ? 'Please select email template first' : ''">-->
                                <!--<svg-checked></svg-checked>-->
                            <!--</label>-->
                        <!--</label>-->
                        <!--<span class="mtv-primary-color clickable-text" (click)="showNotificationModal('signed_out')">-->
                            <!--Key Signed Out-->
                        <!--</span>-->
                    <!--</div>-->
                    <!--<div class="m-b-xs" *ngIf="settingsEmailMergeService.keySignedOutStaffCheckbox">-->
                        <!--<multiselect-field name="signedOutStaffMultiselect"-->
                                           <!--[data]="settingsEmailMergeService.userRoles"-->
                                           <!--[(ngModel)]="settingsEmailMergeService.signedOutStaffMultiselectArray"-->
                                           <!--(update)="submitNotificationsField()">-->
                        <!--</multiselect-field>-->
                    <!--</div>-->

                    <!--<div class="m-b-xs filter-checkbox">-->
                        <!--<label class="img-checkbox">-->
                            <!--<input type="checkbox"-->
                                   <!--[(ngModel)]="settingsEmailMergeService.keyReturnedStaffCheckbox"-->
                                   <!--[disabled]="!emailTemplateIsSet('returned')"-->
                                   <!--name="keyReturnedStaffCheckbox"-->
                                   <!--id="keyReturnedStaffCheckbox"-->
                                   <!--(change)="submitNotificationsField()">-->
                            <!--<label for="keyReturnedStaffCheckbox"-->
                                   <!--[title]="!emailTemplateIsSet('returned') ? 'Please select email template first' : ''">-->
                                <!--<svg-checked></svg-checked>-->
                            <!--</label>-->
                        <!--</label>-->
                        <!--<span class="mtv-primary-color clickable-text" (click)="showNotificationModal('returned')">-->
                            <!--Key Returned-->
                        <!--</span>-->
                    <!--</div>-->
                    <!--<div class="m-b-xs" *ngIf="settingsEmailMergeService.keyReturnedStaffCheckbox">-->
                        <!--<multiselect-field name="returnedStaffMultiselect"-->
                                           <!--[data]="settingsEmailMergeService.userRoles"-->
                                           <!--[(ngModel)]="settingsEmailMergeService.returnedStaffMultiselectArray"-->
                                           <!--(update)="submitNotificationsField()">-->
                        <!--</multiselect-field>-->
                    <!--</div>-->
                <!--</div>-->
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-email-merge/settings-email-merge-detailed-view/settings-email-merge-detailed-view.component.html